import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import { NODE_ENV } from "../constants/env";
import fr from "./fr";
import en from "./en";
import es from "./es";

const DEFAULT_LNG = "fr";
const DEFAULT_NS = "layout";

const i18nOptions = {
  lng: DEFAULT_LNG,
  fallbackLng: DEFAULT_LNG,
  debug: NODE_ENV !== "production",
  keySeparator: false,
  defaultNS: DEFAULT_NS,
  resources: {
    fr,
    en,
    es
  },
  react: {
    wait: true
  },
  interpolation: {
    escapeValue: false
  }
};

i18n
  .use(initReactI18next)
  .init(i18nOptions);

export default i18n;



// WEBPACK FOOTER //
// ./src/i18n/index.js